export const API_URL = "https://apikumbharmangalam.in/";
export const Website_URL = 'https://kumbharmangalam.com/'

export const maritial_statusValues = [
  "unmarried",
  "divorcee",
  "widowed",
];


export const siblingsCount = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export const complexionValues = [
  "fair",
  "gora",
  "sawala",
  "gavhal",
  "nimgora",
  "black",
  "gora,smart",
  "fair,smart",
  "gavhal,smart",
];
export const rashiValues = [
  "mesh",
  "vrushabh",
  "mithun",
  "kark",
  "sinha",
  "kanya",
  "tula",
  "vrischik",
  "dhanu",
  "makar",
  "kumbh",
  "meen",
];
export const nakshatraValues = [
  "ashwini",
  "ardra",
  "aslesha",
  "anuradha",
  "bharani",
  "chitra",
  "dhanishta",
  "hasta",
  "jyeshta",
  "krittika",
  "moola",
  "magha",
  "mrigasira",
  "pushya",
  "purva",
  "phalgini",
  "purva",
  "bhadra",
  "purva",
  "shadha",
  "punarvasu",
  "rohini",
  "swati",
  "revati",
  "shattarka",
  "shravan",
  "uttara",
  "phalguni",
  "bhadra",
  "shadha",
  "vishakha",
];
export const charanValues = ["1", "2", "3", "4"];
export const nadiValues = ["adhya", "madhya", "antya"];
export const ganValues = ["dev gan", "manushya gan", "rakshas gan"];
export const mangalValues = ["yes", "no", "saumya", "nirdosh", "not known"];
export const occupationTypeValues = [
  "not specific",
  "no service or pursuing education",
  "private service",
  "own business or own practice",
  "government service",
];
export const ageValues = [
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
];
export const committeeMembers = [
  "hemant ganesh khatavkar, 9822198820",
  "balasaheb jorvekar, 9325073766",
  "balasaheb tukaram sonawane, 9881103090",
  "yashwant shivram kumbhar, 9850076381",
  "pundalik tryambak sonawane, 9325573841",
  "dhulappa dnyanu kumbhar, 8379963935",
  "adv. Ravindra tryambak sonawane, 9421519162",
  "prakash vitthal sonwale, 9673781435",
  "avinash vishwanath kolhade, 9960500551",
  "bhatu ashok kumbhar, 9665811547",
  "dilip shankar raje, 9822059366",
];
